/**
 * @flow
 * @relayHash 8882593afc422a3f80d769cf8846b113
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type calculatePositionsInput = {|
  event_id?: ?number,
  game_id?: ?number,
  clientMutationId?: ?string,
|};
export type calculatePositionsMutationVariables = {|
  input: calculatePositionsInput
|};
export type calculatePositionsMutationResponse = {|
  +calculatePositions: ?{|
    +code: ?number,
    +message: ?string,
  |}
|};
export type calculatePositionsMutation = {|
  variables: calculatePositionsMutationVariables,
  response: calculatePositionsMutationResponse,
|};
*/


/*
mutation calculatePositionsMutation(
  $input: calculatePositionsInput!
) {
  calculatePositions(input: $input) {
    code
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "calculatePositionsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "calculatePositions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "calculatePositionsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "calculatePositionsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "calculatePositionsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "calculatePositionsMutation",
    "id": null,
    "text": "mutation calculatePositionsMutation(\n  $input: calculatePositionsInput!\n) {\n  calculatePositions(input: $input) {\n    code\n    message\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd1115b6b0777b32c56d3e562bad3f818';
module.exports = node;
